import { render, staticRenderFns } from "./browse-gallery-modal.vue?vue&type=template&id=4de0fa82&scoped=true&"
import script from "./browse-gallery-modal.vue?vue&type=script&lang=ts&"
export * from "./browse-gallery-modal.vue?vue&type=script&lang=ts&"
import style0 from "./browse-gallery-modal.vue?vue&type=style&index=0&id=4de0fa82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de0fa82",
  null
  
)

export default component.exports